import styles from './NotesPage.module.css';
import Dropdown from './../../../components/Dropdown/Dropdown';

import Dynamic from './../../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from './../../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from './../../../components/PaginationTable/PaginationTable';

import IconAndName from './../../../components/IconAndName/IconAndName';
import { IoAddCircleOutline } from 'react-icons/io5';
import CopyRight from './../../../components/CopyRight/CopyRight';

const data = [
  {
    _id: '1',
    createdBy: 'Darshan',
    time: '10:35 PM',
    date: '10/06/2007',
    note: 'Read the notes here ...',
    link: 'img.png',
  },
  {
    _id: '2',
    createdBy: 'Darshan',
    time: '10:35 PM',
    date: '10/06/2007',
    note: 'Read the notes here ...',
    link: 'img.png',
  },
  {
    _id: '3',
    createdBy: 'Darshan',
    time: '10:35 PM',
    date: '10/06/2007',
    note: 'Read the notes here ...',
    link: 'img.png',
  },
  {
    _id: '4',
    createdBy: 'Darshan',
    time: '10:35 PM',
    date: '10/06/2007',
    note: 'Read the notes here ...',
    link: 'img.png',
  },
];

function NotesPage() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        CreatedBy: item.createdBy,

        Time: item.time,
        Date: item.date,
        Note: item.note,
        Link:
          //   <a href={item.link} target="_blank" rel="noreferrer">
          item.link,
        //   </a>
        Action: <span>-</span>,
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    { title: 'Created By', accessor: 'CreatedBy' },

    { title: 'Time', accessor: 'Time' },
    { title: 'Date', accessor: 'Date' },
    { title: 'Note', accessor: 'Note' },
    { title: 'Link', accessor: 'Link' },
    { title: 'Action', accessor: 'Action' },
  ];

  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}></div>
            <div className={styles.Addroom}>
              <Dropdown
                label="Created by"
                options={['Darshan', 'Other']}
                borderRadius="12px"
              />
              <IconAndName
                icon={<IoAddCircleOutline />}
                title="Add Note"
                bgColor="Primary_Color"
                onClick={() => {
                  dispatch(
                    openModal({
                      type: 'addNote',
                      data: { selectStaffOption: true },
                    })
                  );
                }}
              />
            </div>
          </div>

          <div className={styles.dynamicdata}>
            <Dynamic
              headings={headingsData}
              columnData={displayData.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )}
            />
          </div>
          <div className={styles.paginationTable}>
            <PaginationTable
              data={displayData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>
      <div>
        <CopyRight />
      </div>
    </>
  );
}

export default NotesPage;
